import MainLocalVideoListView from "../../components/video/local/MainLocalVideoListView";
import {Col, Row, Spin, Tabs, Tag} from "antd";
import {VideoCameraOutlined} from "@ant-design/icons";
import adminService from "../../service/adminService";
import {ADMIN_VERIFICATION_TYPE} from "../../util/Constants";
import ErrorHandler from "../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {WorkbasketTableDto} from "../../dto/admin/WorkbasketTableDto";
import TabPane = Tabs;

interface WorkbasketPendingWrapper {
    workBasketPendingList: WorkbasketTableDto[]
}

const MainLocalVideoListViewPage = () => {
    const [videoVerificationPendingList, setVideoVerificationPendingList] = useState([])
    const [videoVerificationPendingAssignedList, setVideoVerificationPendingAssignedList] = useState<WorkbasketTableDto[]>([])
    const [videoVerificationTodayList, SetVideoVerificationAssignedTodayList] = useState<WorkbasketTableDto[]>([])
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        getPendingVideoVerificationList(ADMIN_VERIFICATION_TYPE.CUSTOMER_VIDEO_VERIFICATION)
        getPendingAssignedVideoVerificationList(ADMIN_VERIFICATION_TYPE.CUSTOMER_VIDEO_VERIFICATION)
    }, [])
    const getPendingVideoVerificationList = (adminVerificationType: ADMIN_VERIFICATION_TYPE) => {
        setIsLoading(true)
        adminService.getPendingVideoVerificationWorkList(adminVerificationType).then((res) => {
            if (null != res.data.results) {
                setVideoVerificationPendingList(null != res.data.results.videoAdminPendingBasket ? res.data.results.videoAdminPendingBasket: [])
                setIsLoading(false)
            }

        }).catch((reason) => {
            setIsLoading(false)
            ErrorHandler.handleError(reason);
        });
    }
    const getPendingAssignedVideoVerificationList = (adminVerificationType: ADMIN_VERIFICATION_TYPE) => {
        setIsLoading(true)
        adminService.getAssignedVideoVerificationWorkListByUser(adminVerificationType).then((res) => {
            if (null != res.data.results) {
                let results = res.data.results;
                setVideoVerificationPendingAssignedList(results.adminWorkBasketDtoList)
                let filteredListToday = results.adminWorkBasketDtoList.filter((data: WorkbasketTableDto) => data.istoday);
                SetVideoVerificationAssignedTodayList(filteredListToday)
                setIsLoading(false)
            }

        }).catch((reason) => {
            setIsLoading(false)
            ErrorHandler.handleError(reason);
        });
    }
    const tableUpdateFunc = (data: boolean) => {
        getPendingVideoVerificationList(ADMIN_VERIFICATION_TYPE.CUSTOMER_VIDEO_VERIFICATION)
        getPendingAssignedVideoVerificationList(ADMIN_VERIFICATION_TYPE.CUSTOMER_VIDEO_VERIFICATION)
    }
    // console.log(videoVerificationPendingList.map((data) => data.length))
    return (
        <Spin spinning={isLoading} size={"large"}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <VideoCameraOutlined />
                        </div>
                         Video Verification
                    </h2>
                </Col>
            </Row>

            <Row gutter={[16, 16]} className='margin_top_30'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Tabs type="card" defaultActiveKey="1">
                        {
                            videoVerificationPendingList && videoVerificationPendingList.length > 0 ?
                                videoVerificationPendingList.map((workbasketData, index) => {
                                    return <TabPane
                                        tab={<>Basket {index+1} <Tag style={{marginLeft: 5}}
                                            color="blue">{workbasketData.length ?? 0}</Tag></>}
                                        key={index+1}>
                                        <MainLocalVideoListView isMyWorkBasket={false}
                                                                dataSource={workbasketData}
                                                                tableUpdateFunc={tableUpdateFunc}
                                        />
                                    </TabPane>
                                }) : <TabPane
                                    tab={<>Pending List <Tag style={{marginLeft: 5}}
                                        color="blue">{0}</Tag></>}
                                    key={1}>
                                    <MainLocalVideoListView isMyWorkBasket={false}
                                                            dataSource={[]}
                                                            tableUpdateFunc={tableUpdateFunc}
                                    />
                                </TabPane>
                        }

                        <TabPane tab={<> My Today Work Basket <Tag style={{marginLeft: 5}}
                            color="green">{videoVerificationTodayList.length ?? 0}</Tag></>}
                                 key={videoVerificationPendingList.length + 2}>
                            <MainLocalVideoListView isMyWorkBasket={true} tableUpdateFunc={tableUpdateFunc}
                                                    dataSource={videoVerificationTodayList}
                            />
                        </TabPane>
                        <TabPane tab={<> My Work Basket <Tag style={{marginLeft: 5}}
                            color="green">{videoVerificationPendingAssignedList.length ?? 0}</Tag></>}
                                 key={videoVerificationPendingList.length + 3}>
                            <MainLocalVideoListView isMyWorkBasket={true} tableUpdateFunc={tableUpdateFunc}
                                                    dataSource={videoVerificationPendingAssignedList}
                            />
                        </TabPane>


                    </Tabs>
                </Col>
            </Row>
        </Spin>


    )
}

export default MainLocalVideoListViewPage;
